import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  Stack,
  UnorderedList,
  ListItem,
  Link,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import NavigationBar from "../NavigationBar";

export default function Photos() {
  const galleries = [
    {
      title: "Hong Kong 2025",
      href: "/photos/hongkong2025",
    },
  ];

  return (
    <Box bg="gray.800" minH="100vh" color="white">
      <NavigationBar />
      <Box h={{ base: 20, md: 24 }} />
      <Container maxW="5xl" pb={{ base: 12, md: 16 }}>
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Heading size="lg" color="white">
              Collections
            </Heading>
            <UnorderedList spacing={3} stylePosition="outside" pl={4}>
              {galleries.map((gallery) => (
                <ListItem key={gallery.title} color="white">
                  <Link
                    as={RouterLink}
                    to={gallery.href}
                    color="white"
                    _hover={{ color: "teal.200", textDecoration: "underline" }}
                  >
                    {gallery.title}
                  </Link>
                </ListItem>
              ))}
            </UnorderedList>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
